module.exports = __webpack_public_path__ + "img/slide-17.83f08b36.png";